import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./Adventure.css";

const Adventure = () => {
  const { id } = useParams();

  const [adventures, setAdventures] = useState([]);
  const [filterAdventures, setFilterAdventures] = useState([]);
  const [duration, setDuration] = useState("");
  const [category, setCategory] = useState("");

  const getAdventure = async () => {
    try {
      let response = await axios.get(
        `https://mtrip-dynamic.herokuapp.com/adventures?city=${id}`
      );
      setAdventures([...response.data]);
      setFilterAdventures([...response.data]);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => getAdventure(), []);

  useEffect(() => {
    const data = adventures.filter(
      (adventure) => adventure.category === category
    );
    setFilterAdventures([...data]);
  }, [category]);

  useEffect(() => {
    let num = duration.split("-");
    //converted into an array
    const [low, high] = num;
    // destructuring of elements
    const data = adventures.filter(
      (adventure) => adventure.duration > low && adventure.duration <= high
    );
    setFilterAdventures([...data]);
  }, [duration]);

  return (
    <>
      <div className="container">
        <div className="row">
          <h1>Explore all adventures</h1>
          <p className="fs-4">
            Here's a list of places that you can explore in city
          </p>
          <hr />
          <div className="col-lg-5 col-sm-12 col-xs-12 ms-5 d-flex justify-content-between align-items-center">
            <label className="me-2">Filters:</label>
            <select
              className="form-control form-select me-3"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
            >
              <option selected>Filter by duration</option>
              <option value="0-2">0-2 Hours</option>
              <option value="2-6">2-6 Hours</option>
              <option value="6-12">6-12 Hours</option>
              <option value="12">12+ Hours</option>
            </select>

            <select
              className="form-control form-select me-3"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option selected>Add Category</option>
              <option value="Cycling">Cycling Routes</option>
              <option value="HillSide">HillSide Gateways</option>
              <option value="Beaches">Serene Beaches</option>
              <option value="Party">Party Spots</option>
            </select>
          </div>
        </div>
        <hr />

        <div className="row mt-5">
          {filterAdventures.map((adventure) => (
            <div className="col-lg-3 col-sm-6 col-xs-12 mt-3">
              <div className="card star">
                <Link to={`/adventure-detail/${adventure.id}`}>
                  <img
                    src={adventure.image}
                    alt=""
                    className="card-img-top img-fluid"
                  />
                </Link>
                <div className="activity">{adventure.category}</div>
                <div className="card-body">
                  <div className="d-flex justify-content-between">
                    <strong className="disc">{adventure.name}</strong>
                    <span className="ring">₹{adventure.costPerHead}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <strong className="disc">Duration</strong>
                    <span className="ring">{adventure.duration} Hours</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Adventure;
